// removed by extract-text-webpack-plugin
module.exports = {"totheleft":"_3fj0gTvm5GV_2E8xSjnEwi_0","custom-control":"_32DmnV21dvuy4AxfmYYS_4_0","form-group":"_3yNdfDQBQDK5RZ6gDcFWFN_0","required":"QUrNSV13J-gEFjmrruKzk_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ac1a1a1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ResourceAdd.vue
// module id = ju7A
// module chunks = 1